export const blockIconsTextformattingBookNew = (
	<span className='material-symbols-outlined'>book</span>
);
